import { useEffect } from 'react'

import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { WarningIcon } from '@signals'
import { Page } from '@templates'
import { Button } from '@interco/inter-ui/components/Button'
import { ApplicationState } from '@store/types'
import { validaEnvHomeByBridge } from '@utils/functions'
import { ColorWrapper, TextParagraph, Separator, GridStyled } from '@atoms'
import Tag from '@utils/Tag'
import { BridgeService } from '@services/bridge'
import { useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'
import { OpportunityCard } from '@molecules'
import { Colors } from '@utils/Colors'

import { Content } from './styles'

const SemEmprestimo = () => {
  const { origemGoBack, isApp } = useSelector((state: ApplicationState) => state.ui.navigation)
  const { step } = useLocation().state || {}

  useTrackingRefin(step ? StepRefin.SEM_EMPRESTIMO_DADOS_2 : StepRefin.SEM_EMPRESTIMO)

  useEffect(() => {
    BridgeService.tac({
      name: 'sem_contratos',
      actions: ['buscar_contratos'],
    })
  }, [])

  useEffect(() => {
    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:feedback',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: '',
        section: 'feedback',
        sub_section: '',
        step: '',
        scenario: 'sem emprestimo',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'page_loaded',
        element_name: 'Sem emprestimo',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:feedback',
        section: 'feedback',
        sub_section: '',
        step: '',
        scenario: 'sem emprestimo',
      })
    }
  }, [isApp])

  const redirectGoBack = () => validaEnvHomeByBridge(String(origemGoBack), isApp) || ''

  const handleOpenEmprestimoConsignado = () => {
    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:feedback',
        ref_type: 'botao',
        content_action: 'Toque',
        action_id: 'Conheça outras opções',
        section: 'feedback',
        sub_section: '',
        step: '',
        scenario: 'conheça outras opções',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'click button',
        element_name: 'Conheça outras opções',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:feedback',
        section: 'feedback',
        sub_section: '',
        step: '',
        scenario: 'conheça outras opções',
      })
    }

    const deepLink = String(process.env.REACT_APP_HOME_SIMULADOR_NOVO_PUBLICO_DEEPLINK || '')
    const site = String(process.env.REACT_APP_HOME_SIMULADOR_NOVO_PUBLICO || '')

    if (!isApp && site) window.location.href = site
    else if (isApp && deepLink) BridgeService.openDeepLink(deepLink)
  }

  return (
    <Page
      footerTwoButtonsSpace="200px"
      showLeftIcon={false}
      stickyFooter={
        <Button
          onClick={() => {
            window.location.href = redirectGoBack()
          }}
        >
          Voltar para home
        </Button>
      }
    >
      <Content>
        <GridStyled margin="0">
          <div style={{ padding: '16px', borderRadius: '60px', background: Colors.GRAY100 }}>
            <WarningIcon />
          </div>
        </GridStyled>
        <ColorWrapper fontWeight="600" margin="24px 0 8px 0" style={{ textAlign: 'center' }}>
          <TextParagraph variant="headline-h1">
            No momento, você não possui contratos elegíveis para refinanciamento.
          </TextParagraph>
        </ColorWrapper>

        <Separator variant="small" margin="8px 0 24px 0" />
        <ColorWrapper
          fontWeight="700"
          margin="24px 0 8px 0"
          style={{ marginBottom: '24px', alignSelf: 'flex-start' }}
        >
          <TextParagraph variant="headline-h2">Conheça outras opções</TextParagraph>
        </ColorWrapper>
        <OpportunityCard
          subtitle="Empréstimo consignado"
          description="As melhores parcelas e taxas reduzidas."
          ariaLabel="Oportunidade"
          onClick={() => handleOpenEmprestimoConsignado()}
          onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleOpenEmprestimoConsignado()
            }
          }}
        />
      </Content>
    </Page>
  )
}
export default SemEmprestimo
